module.exports = __webpack_public_path__ + "static/media/Bulldog448_4c.f04a2756.svg";